<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getPutawayHeaders"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-putaway-header-no" label-cols-sm="4" label-cols-lg="3" label="Putaway Header No" label-for="filter-putaway-header-no" size="sm" :model.sync="filter.putawayHeaderNo" />
						<app-input-combobox-autocomplete :options="scannedBys" optionsLabel="firstName" optionsKey="userName" label-cols-sm="4" label-cols-lg="3" label="Scanned By" id="filter-scanned-by" size="sm" :model.sync="filter.scannedById" :selected="filter.scannedBy" :isSelectMethodExists="true" @onSelectMethod="setSelectedScannedBy" @input="getScannedBys" @focus="getScannedBys" />
						<app-input-combobox-autocomplete :options="putawayCategorys" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Putaway Category" id="filter-putaway-category" size="sm" :model.sync="filter.putawayCategoryId" :selected="filter.putawayCategory" :isSelectMethodExists="true" @onSelectMethod="setSelectedPutawayCategory" @input="getPutawayCategorys" @focus="getPutawayCategorys" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Document Status" id="filter-document-status" size="sm" :model.sync="filter.documentStatusId" :selected="filter.documentStatus" :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" @input="getDocumentStatuss" @focus="getDocumentStatuss" />
						<app-input-datepicker-range  id="fieldset-process-date" label-cols-sm="4" label-cols-lg="3" label="Process Date" size="sm" :modelFrom.sync="filter.processDateFrom" :modelTo.sync="filter.processDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Area" id="filter-area" size="sm" :model.sync="filter.areaId" :selected="filter.area" :isSelectMethodExists="true" @onSelectMethod="setSelectedArea" @input="getAreas" @focus="getAreas" />

					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Putaway Header</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="true" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="/files/PutawayHeader/PutawayHeader.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/putawayheader/scan" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/putawayheader/scan" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="true" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
					
					<b-overlay v-if="isShowDeleteButton"
							   :show="isDeleteBusy"
							   rounded
							   opacity="0.6"
							   spinner-small
							   spinner-variant="primary"
							   class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-putawayheader" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="putawayHeaders" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="putawayHeaders.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Putaway Header No" class="table-filter">
							<b-form-input id="input-putaway-header-no-table" @input="getPutawayHeadersWithoutLoading" v-model="filter.putawayHeaderNo" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Scanned By" class="table-filter">
							<app-input-combobox-autocomplete :options="scannedBys" optionsLabel="firstName" optionsKey="userName" label-cols-sm="4" label-cols-lg="3" label="Scanned By" id="filter-scanned-by" size="sm" :model.sync="filter.scannedById" :selected="filter.scannedBy" :isSelectMethodExists="true" @onSelectMethod="setSelectedScannedByAndSearch" @input="getScannedBys" @focus="getScannedBys" />
						</b-th>
						<b-th stacked-heading="Putaway Category" class="table-filter">
							<app-input-combobox-autocomplete :options="putawayCategorys" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Putaway Category" id="filter-putaway-category" size="sm" :model.sync="filter.putawayCategoryId" :selected="filter.putawayCategory" :isSelectMethodExists="true" @onSelectMethod="setSelectedPutawayCategoryAndSearch" @input="getPutawayCategorys" @focus="getPutawayCategorys" />
						</b-th>
						<b-th stacked-heading="Document Status" class="table-filter">
							<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Document Status" id="filter-document-status" size="sm" :model.sync="filter.documentStatusId" :selected="filter.documentStatus" :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatusAndSearch" @input="getDocumentStatuss" @focus="getDocumentStatuss" />
						</b-th>
						<b-th stacked-heading="Process Date" class="table-filter">
							<b-form-datepicker boundary="viewport" placeholder="" id="input-process-date-from-table" reset-button @input="getPutawayHeadersWithoutLoading" v-model="filter.processDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
							<b-form-datepicker boundary="viewport" placeholder="" id="input-process-date-to-table" reset-button @input="getPutawayHeadersWithoutLoading" v-model="filter.processDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
						</b-th>
						<b-th stacked-heading="Area" class="table-filter">
							<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Area" id="filter-area" size="sm" :model.sync="filter.areaId" :selected="filter.area" :isSelectMethodExists="true" @onSelectMethod="setSelectedAreaAndSearch" @input="getAreas" @focus="getAreas" />
						</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(putawayheaderno)="row">

                <a @click="() => ( $router.push({ name: 'putawayheaderdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.putawayHeaderNo != null && row.item.putawayHeaderNo != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.putawayHeaderNo.slice(0, 30) + (row.item.putawayHeaderNo.length > 30 ? "..." : "" ) : row.item.putawayHeaderNo : "" }}
						</a>
            
					</template>

						<template v-slot:cell(scannedBy)="row">
							{{ row.item.scannedBy != null ? row.item.scannedBy.firstName : "" }}
						</template>
						<template v-slot:cell(putawayCategory)="row">
							{{ row.item.putawayCategory != null ? row.item.putawayCategory.name : "" }}
						</template>
						<template v-slot:cell(documentStatus)="row">
							{{ row.item.documentStatus != null ? row.item.documentStatus.name : "" }}
						</template>
						<template v-slot:cell(processDate)="row">
							{{ row.item.processDate | moment("DD-MMM-YYYY") }}
						</template>
						<template v-slot:cell(area)="row">
							{{ row.item.area != null ? row.item.area.code : "" }}
						</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="isShowDeleteButton">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.putawayCategoryId" label="Putaway Category" :selected="row.item.putawayCategory != null ? row.item.putawayCategory.name : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.documentStatusId" label="Document Status" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-datepicker  id="fieldset-process-date" label-cols-lg="12"  label="Process Date" size="sm" :model.sync="row.item.processDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.areaId" label="Area" :selected="row.item.area != null ? row.item.area.code : ''" :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(putawayHeadersPaging != null ? putawayHeadersPaging.dataCount : 0)"
									:per-page="(putawayHeadersPaging != null ? putawayHeadersPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-putawayheader.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-putawayheader.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import PutawayHeader from '@/models/PutawayHeader/PutawayHeader';
import PutawayHeaderList from '@/models/PutawayHeader/PutawayHeaderList';
import PutawayHeaderFilter from '@/filters/PutawayHeader/PutawayHeaderFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import PutAwayCategoryFilter from '@/filters/PutAwayCategory/PutAwayCategoryFilter';
import PutAwayCategory from '@/models/PutAwayCategory/PutAwayCategory';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AreaFilter from '@/filters/Area/AreaFilter';
import Area from '@/models/Area/Area';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		PutawayHeader, 
		PutawayHeaderList, 
		PutawayHeaderFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"putawayHeaderNo": {}, "class" : "th-putaway-header-no first-child", "label" : "Putaway Header No", key: 'putawayHeaderNo', sortable: true}, 
				{"scannedBy": {}, "class" : "th-scanned-by", "label" : "Scanned By", key: 'scannedBy', sortable: true}, 
				{"putawayCategory": {}, "class" : "th-putaway-category last-child", "label" : "Putaway Category", key: 'putawayCategory', sortable: true}, 
				{"documentStatus": {}, "class" : "th-document-status d-stack-none", "label" : "Document Status", key: 'documentStatus', sortable: true}, 
				{"processDate": {}, "class" : "th-process-date d-stack-none", "label" : "Process Date", key: 'processDate', sortable: true}, 
				{"area": {}, "class" : "th-area d-stack-none", "label" : "Area", key: 'area', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			putawayHeaders: [],
			putawayHeadersPaging: {},
			scannedBys : [],
			putawayCategorys : [],
			documentStatuss : [],
			areas : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
			
		}
	},	methods : {
		getPutawayHeaders : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PutawayHeader.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.putawayHeaders = result.data
					this.putawayHeadersPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getPutawayHeadersWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PutawayHeader.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.putawayHeaders = result.data
					this.putawayHeadersPaging = result
				}
			})
			.catch(error => {});
		},
		getScannedBys : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			await UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.scannedBys = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedScannedBy(item) {
			if(item == undefined || item == null) {
				this.filter.scannedById = null;
				this.filter.scannedBy = null;
			} else {
				this.filter.scannedById = item.userName;
				this.filter.scannedBy = item;
			}
		},
		async setSelectedScannedByAndSearch(item) {
			this.setSelectedScannedBy(item);
			await this.getPutawayHeadersWithoutLoading();
		},
		getPutawayCategorys : async function(input) {
			let filter = new PutAwayCategoryFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await PutAwayCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.putawayCategorys = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPutawayCategory(item) {
			if(item == undefined || item == null) {
				this.filter.putawayCategoryId = null;
				this.filter.putawayCategory = null;
			} else {
				this.filter.putawayCategoryId = item.id;
				this.filter.putawayCategory = item;
			}
		},
		async setSelectedPutawayCategoryAndSearch(item) {
			this.setSelectedPutawayCategory(item);
			await this.getPutawayHeadersWithoutLoading();
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.filter.documentStatusId = null;
				this.filter.documentStatus = null;
			} else {
				this.filter.documentStatusId = item.id;
				this.filter.documentStatus = item;
			}
		},
		async setSelectedDocumentStatusAndSearch(item) {
			this.setSelectedDocumentStatus(item);
			await this.getPutawayHeadersWithoutLoading();
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			await Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedArea(item) {
			if(item == undefined || item == null) {
				this.filter.areaId = null;
				this.filter.area = null;
			} else {
				this.filter.areaId = item.id;
				this.filter.area = item;
			}
		},
		async setSelectedAreaAndSearch(item) {
			this.setSelectedArea(item);
			await this.getPutawayHeadersWithoutLoading();
		},

		resetFilter() {
			this.filter = new PutawayHeaderFilter();
			this.getPutawayHeaders();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getPutawayHeaders();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				PutawayHeader.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			PutawayHeader.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			PutawayHeader.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			PutawayHeader.deleteData(this, id).then(result => {
				if (result)
				{
					this.getPutawayHeaders();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				PutawayHeader.deleteMultipleData(this).then(result => {
					this.getPutawayHeaders();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tablePutawayHeaderParent = document.getElementById('table-list-putawayheader').parentNode;
			tablePutawayHeaderParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tablePutawayHeaderParent.scrollWidth - tablePutawayHeaderParent.offsetWidth) == Math.ceil(tablePutawayHeaderParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tablePutawayHeaderParent = document.getElementById('table-list-putawayheader').parentNode;
			tablePutawayHeaderParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tablePutawayHeaderParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new PutawayHeaderFilter();
		// this.getUserInfos()
		// this.getPutAwayCategorys()
		// this.getDocumentStatuss()
		// this.getAreas()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Putaway Header"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getPutawayHeaders();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getPutawayHeaders();
			}
		},
		sortDesc: {
			handler: function() {
				this.getPutawayHeaders();
			}
		},
		currentPage: {
			handler: function() {
				this.getPutawayHeaders();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getPutawayHeaders();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				PutawayHeader.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "putawayheaderindex") {
					this.getPutawayHeadersWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "putaway_header").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
